<template>
  <div>
    <div>
      <search-bar></search-bar>
    </div>
    <div v-if="result && isfound">
      <school-info :info="school_info"></school-info>
    </div>
    <div v-if="result && isfound">
      <v-container fluid grid-list-sm class="py-0">
        <v-card>
          <v-tabs
            v-model="active"
            background-color="primary"
            dark
            slider-color="yellow"
          >
            <v-tab ripple href="#t1" :disabled="!grade.g1">ថ្នាក់ទី ១</v-tab>
            <v-tab ripple href="#t2" :disabled="!grade.g2">ថ្នាក់ទី ២</v-tab>
            <v-tab ripple href="#t3" :disabled="!grade.g3">ថ្នាក់ទី ៣</v-tab>
            <v-tab ripple href="#t4" :disabled="!grade.g4">ថ្នាក់ទី ៤</v-tab>
            <v-tab ripple href="#t5" :disabled="!grade.g5">ថ្នាក់ទី ៥</v-tab>
            <v-tab ripple href="#t6" :disabled="!grade.g6">ថ្នាក់ទី ៦</v-tab>
            <!--
            <v-tab v-for="n in 6" :key="n" :disabled="!`grade.g${n}`" ripple>
              Grade {{n}}
            </v-tab> 
            <v-tab-item v-for="n in 6" :key="n">
              <b>១.ថ្នាក់ទី {{ n }}</b>
              <div v-if="`grade.g${n}>0 && score.sco_g${n}!=null`">
                <grade-16 :scoreData="!`score.sco_g${n}`"></grade-16>  
              </div>
            </v-tab-item>
            -->

            <v-tab-item id="t1">
              <b>១.ថ្នាក់ទី ១</b>
              <div v-if="grade.g1 > 0 && score.sco_g1 != null">
                <grade-16 :scoreData="score.sco_g1"></grade-16>
              </div>
            </v-tab-item>
            <v-tab-item id="t2">
              <b>២.ថ្នាក់ទី ២</b>
              <div v-if="grade.g2 > 0 && score.sco_g2 != null">
                <grade-16 :scoreData="score.sco_g2"></grade-16>
              </div>
            </v-tab-item>
            <v-tab-item id="t3">
              <b>៣.ថ្នាក់ទី ៣</b>
              <div v-if="grade.g3 > 0 && score.sco_g3 != null">
                <grade-16 :scoreData="score.sco_g3"></grade-16>
              </div>
            </v-tab-item>
            <v-tab-item id="t4">
              <b>៤.ថ្នាក់ទី ៤</b>
              <div v-if="grade.g4 > 0 && score.sco_g4 != null">
                <grade-16 :scoreData="score.sco_g4"></grade-16>
              </div>
            </v-tab-item>
            <v-tab-item id="t5">
              <b>៥.ថ្នាក់ទី ៥</b>
              <div v-if="grade.g5 > 0 && score.sco_g5 != null">
                <grade-16 :scoreData="score.sco_g5"></grade-16>
              </div>
            </v-tab-item>
            <v-tab-item id="t6">
              <b>៦.ថ្នាក់ទី ៦</b>
              <div v-if="grade.g6 > 0 && score.sco_g6 != null">
                <grade-16 :scoreData="score.sco_g6"></grade-16>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-container>
    </div>
    <!--
    <div>
      <v-btn @click="next">Tab 3</v-btn>
    </div>
    -->
    <div v-if="isfound && result">
      <navigation-bar></navigation-bar>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SearchBar from "@/components/common/SearchBar.vue";
import SchoolInfo from "@/components/common/SchoolInfo.vue";
import NavigationBar from "@/components/common/NavigationBar.vue";
import Grade16 from "@/components/qemis/Grade16.vue";
import puQemisPriModule from "@/store/modules/puqemispri/index";

export default {
  name: "qemisPrimary",
  components: {
    searchBar: SearchBar,
    schoolInfo: SchoolInfo,
    grade16: Grade16,
    navigationBar: NavigationBar,
  },
  data() {
    return {
      isfound: false,
      active: "t1", // this.$store.state.uiControl.selTab
    };
  },
  methods: {},
  computed: {
    /* eslint-disable */

    result: function () {
      if (this.$store.state.puqemispri.school_dt.res === "1") {
        this.isfound = true;
        this.active = "t1";
        return true;
      } else {
        return false;
      }
    },

    /* eslint-enable */
    ...mapGetters({
      school_info: "puqemispri/getSchoolInfo",
      score: "puqemispri/getScore",
      grade: "puqemispri/getGrade",
      tabCon: "uiControl/getTabConfig",
    }),
    savTab: function () {
      let sTab;
      return sTab;
    },
  },
  mounted() {
    this.$store.dispatch("puqemispri/loadDefaultQEMISpri");
    //this.$store.dispatch("uiControl/setEnableSave");
  },
  beforeDestroy() {
    // this.$store.unregisterModule("puqemispri");
  },
  created() {
    if (!this.$store._modules.root._children[`puqemispri`]) {
      this.$store.registerModule("puqemispri", puQemisPriModule);
    }
  },
};
</script>